let status_prenomina = Object.freeze({
    nueva: 1,
    sin_calcular: 2,
    parcial: 3,
    total: 4,
    cerrada: 5,
    list: [
        {value: 1, text: 'PRENOMINA NUEVA'},
        {value: 2, text: 'PRENOMINA SIN CALCULAR'},
        {value: 3, text: 'PRENOMINA PARCIAL'},
        {value: 4, text: 'PRENOMINA TOTAL'},
        {value: 5, text: 'PRENOMINA CERRADA'},
    ]
});

module.exports = { status_prenomina };
